module.exports = __webpack_public_path__ + "media/images/wgn_logo-a8ef81e661d661c46a00cc800b47ec04.png";